import React, { useState } from 'react';
import { supabase } from './supabaseClient';
import { t } from './i18n';

function SetarePassword({ onSuccess }) {
  const [parola, setParola] = useState('');
  const [confirmare, setConfirmare] = useState('');
  const [loading, setLoading] = useState(false);
  const [eroare, setEroare] = useState('');
  const [succes, setSucces] = useState(false);

  const parolaValida = parola.length >= 8 && parola === confirmare;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setEroare('');

    if (parola.length < 8) {
      setEroare('Parola trebuie să aibă minim 8 caractere.');
      return;
    }
    if (parola !== confirmare) {
      setEroare('Parolele nu coincid.');
      return;
    }

    setLoading(true);
    try {
      const { error } = await supabase.auth.updateUser({ password: parola });
      if (error) throw error;

      // Parola noua inchide toate celelalte sesiuni ale contului (cerut de Luminita,
      // 16 septembrie 2026: parola veche fusese data recenzorilor). Sesiunea de pe
      // acest ecran ramane. Daca deconectarea nu merge, parola e totusi schimbata.
      const { error: eroareSesiuni } = await supabase.auth.signOut({ scope: 'others' });
      if (eroareSesiuni) console.error('Celelalte sesiuni nu s-au inchis:', eroareSesiuni.message);

      window.history.replaceState(null, '', window.location.pathname);
      setSucces(true);
      setTimeout(() => onSuccess(), 2000);
    } catch (err) {
      console.error('Eroare setare parolă:', err);
      setEroare(err.message || 'A apărut o eroare. Te rugăm să încerci din nou.');
      setLoading(false);
    }
  };

  if (succes) {
    return (
      <div style={styles.container}>
        <div style={styles.card}>
          <div style={styles.logo}>NM Social</div>
          <div style={styles.iconSucces}>✓</div>
          <h1 style={{ ...styles.titlu, color: '#1A6B3C' }}>{t('setareParola', 'parolaSetata')}</h1>
          <p style={styles.subtitlu}>{t('setareParola', 'teRedirectionam')}</p>
        </div>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.logo}>NM Social</div>
        <h1 style={styles.titlu}>{t('setareParola', 'seteazaParola')}</h1>
        <p style={styles.subtitlu}>
          Bine ai venit la NM Social! Pentru a-ți securiza contul, te rugăm să îți alegi o parolă.
        </p>

        {eroare && <div style={styles.eroare}>{eroare}</div>}

        <form onSubmit={handleSubmit} style={styles.form}>
          <div style={styles.camp}>
            <label style={styles.label}>{t('setareParola', 'parolaNoua')}</label>
            <input
              type="password"
              value={parola}
              onChange={(e) => setParola(e.target.value)}
              placeholder="Minim 8 caractere"
              style={styles.input}
              autoFocus
              autoComplete="new-password"
            />
          </div>

          <div style={styles.camp}>
            <label style={styles.label}>{t('setareParola', 'confirmaParola')}</label>
            <input
              type="password"
              value={confirmare}
              onChange={(e) => setConfirmare(e.target.value)}
              placeholder={t('setareParola', 'repetaParola')}
              style={styles.input}
              autoComplete="new-password"
            />
            {confirmare.length > 0 && parola !== confirmare && (
              <div style={styles.hintEroare}>Parolele nu coincid.</div>
            )}
          </div>

          <button
            type="submit"
            disabled={loading || !parolaValida}
            style={{
              ...styles.buton,
              opacity: loading || !parolaValida ? 0.5 : 1,
              cursor: loading || !parolaValida ? 'not-allowed' : 'pointer',
            }}
          >
            {loading ? 'Se setează...' : 'Setează parola'}
          </button>
        </form>
      </div>
    </div>
  );
}

const styles = {
  container: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#F5F9F6',
    padding: '20px',
    fontFamily: "'DM Sans', sans-serif",
  },
  card: {
    backgroundColor: '#FFFFFF',
    borderRadius: '16px',
    padding: '40px',
    maxWidth: '500px',
    width: '100%',
    boxShadow: '0 4px 20px rgba(26, 107, 60, 0.08)',
  },
  logo: {
    fontFamily: "'DM Serif Display', serif",
    fontSize: '28px',
    color: '#1A6B3C',
    marginBottom: '8px',
  },
  titlu: {
    fontFamily: "'DM Serif Display', serif",
    fontSize: '32px',
    color: '#0F3D22',
    margin: '0 0 12px 0',
  },
  subtitlu: {
    fontSize: '16px',
    color: '#666',
    marginBottom: '32px',
    lineHeight: '1.5',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
  },
  camp: {
    display: 'flex',
    flexDirection: 'column',
    gap: '6px',
  },
  label: {
    fontSize: '13px',
    fontWeight: 600,
    color: '#0F3D22',
    letterSpacing: '0.02em',
  },
  input: {
    padding: '12px 14px',
    fontSize: '15px',
    fontFamily: "'DM Sans', sans-serif",
    border: '1.5px solid #D1E8DA',
    borderRadius: '8px',
    outline: 'none',
    color: '#1A1A1A',
    backgroundColor: '#FFFFFF',
    transition: 'border-color 0.15s',
  },
  hintEroare: {
    fontSize: '12px',
    color: '#B91C1C',
    marginTop: '4px',
  },
  eroare: {
    backgroundColor: '#FEF2F2',
    color: '#B91C1C',
    padding: '12px 16px',
    borderRadius: '8px',
    fontSize: '14px',
    marginBottom: '20px',
    border: '1px solid #FCA5A5',
  },
  buton: {
    width: '100%',
    padding: '14px 24px',
    backgroundColor: '#0F3D22',
    color: '#FFFFFF',
    border: 'none',
    borderRadius: '8px',
    fontSize: '16px',
    fontWeight: 600,
    fontFamily: "'DM Sans', sans-serif",
    transition: 'all 0.2s',
    marginTop: '8px',
  },
  iconSucces: {
    width: '64px',
    height: '64px',
    borderRadius: '50%',
    backgroundColor: '#D4EDE0',
    color: '#1A6B3C',
    fontSize: '36px',
    fontWeight: 700,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '16px 0 24px 0',
  },
};

export default SetarePassword;
